import { Component, OnInit } from '@angular/core';
import { reportStorageInfo } from 'src/app/dashboards/models';
import { property } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';

@Component({
    selector: 'app-reports-dialog-subscription-info',
    templateUrl: './reports-dialog-subscription-info.component.html',
    styleUrls: ['./reports-dialog-subscription-info.component.scss'],
    standalone: false
})
export class ReportsDialogSubscriptionInfoComponent implements OnInit {

  countries: Array<property> = [];
  storageInfo: Array<reportStorageInfo> = [];
  selected: reportStorageInfo;
  selectedStorageId:number;
  constructor(private dashboardsService: DashboardService,) { }

  ngOnInit(): void {
    this.dashboardsService.getStorageInfo().subscribe(si => {
      this.storageInfo = si;
      this.selected = this.storageInfo?.find(x => x != null);
      this.selectedStorageId = this.selected?.id;
    })
  }

  setCountry($event) {
    this.selected = $event;
    this.selectedStorageId = this.selected?.id;
  }
}
